export function taskDeadlineLabel(task) {
  const balance = Number(task.days_balance || 0);
  if (task.status === 'finalizado') return balance < 0
    ? `Finalizada con ${-balance} ${balance === -1 ? 'día' : 'días'} de atraso`
    : 'Finalizada en plazo';
  if (balance < 0) return `${-balance} ${balance === -1 ? 'día' : 'días'} de atraso`;
  if (balance === 0) return 'Vence hoy';
  return balance === 1 ? '1 día restante' : `${balance} días restantes`;
}

export function taskDisplayDate(value) {
  const [year, month, day] = String(value || '').slice(0, 10).split('-');
  return year && month && day ? `${day}/${month}/${year}` : '—';
}
